import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from '../login/login.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authService: LoginService,
    private router: Router
  ) {}

  public getToken(): string {
    return localStorage.getItem('token'); 
  }

  canActivate(): boolean {
    if (!this.authService.isLoggedIn) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
